import { fetchAiTrusteeSidebarStatus } from '@/api/leoAiTrusteeAdmin'

const state = {
  byEnName: {},
  assessedAt: '',
  deviceFamily: 'coffee_machine',
  loading: false,
  lastError: ''
}

const mutations = {
  SET_SIDEBAR_AI_STATUS (state, payload) {
    state.byEnName = (payload && payload.byEnName) || {}
    state.assessedAt = (payload && payload.assessedAt) || ''
    if (payload && payload.deviceFamily) state.deviceFamily = payload.deviceFamily
    state.lastError = ''
  },
  SET_SIDEBAR_AI_LOADING (state, v) {
    state.loading = !!v
  },
  SET_SIDEBAR_AI_ERROR (state, msg) {
    state.lastError = msg || ''
  }
}

const actions = {
  async refreshSidebarAiStatus ({ commit, state }, deviceFamily) {
    const family = deviceFamily || state.deviceFamily || 'coffee_machine'
    commit('SET_SIDEBAR_AI_LOADING', true)
    try {
      const res = await fetchAiTrusteeSidebarStatus({ deviceFamily: family })
      const body = (res && res.data) || {}
      commit('SET_SIDEBAR_AI_STATUS', body)
      return body
    } catch (e) {
      commit('SET_SIDEBAR_AI_ERROR', (e && e.message) || 'sidebar_ai_status_failed')
      return null
    } finally {
      commit('SET_SIDEBAR_AI_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebarAi.js